interface Review {
  name: string;
  avatar: string;
  rating: number;
  comment: string;
  date: string;
}

interface ReviewsSectionProps {
  reviews: Review[];
  rating: number;
  reviewCount: number;
}

function StarRating({ rating, size = 'sm' }: { rating: number; size?: 'sm' | 'lg' }) {
  const starSize = size === 'lg' ? 'text-2xl' : 'text-sm';
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`${starSize} ${
            star <= Math.floor(rating)
              ? 'ri-star-fill text-yellow-400'
              : star - 0.5 <= rating
              ? 'ri-star-half-fill text-yellow-400'
              : 'ri-star-line text-gray-300'
          }`}
        ></i>
      ))}
    </div>
  );
}

export default function ReviewsSection({ reviews, rating, reviewCount }: ReviewsSectionProps) {
  return (
    <div className="mt-12">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-bold text-gray-900">Customer Reviews</h2>
        <div className="flex items-center gap-3">
          <StarRating rating={rating} size="lg" />
          <span className="text-2xl font-bold text-gray-900">{rating}</span>
          <span className="text-gray-500 text-sm">({reviewCount} reviews)</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((review, index) => (
          <div key={index} className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="font-semibold text-gray-900 text-sm">{review.name}</p>
                <p className="text-gray-400 text-xs">{review.date}</p>
              </div>
            </div>
            <StarRating rating={review.rating} />
            <p className="text-gray-600 text-sm mt-3 leading-relaxed">{review.comment}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
